/**
 * API Migration Configuration
 *
 * This file centralizes the configuration for migrating from the old Vercel API
 * to the new Azure API system.
 */

import { ZORROCORE_BASE_URL } from "../components/utils/apiConfig";

/**
 * Migration configuration
 */
export const MIGRATION_CONFIG = {
  // Main flag to control which API system to use
  // Set to true to use new Azure system, false for old Vercel system
  USE_NEW_API: process.env.REACT_APP_USE_NEW_API === "true" || false,

  // API URLs
  OLD_API_URL:
    process.env.NODE_ENV === "development" ? "http://localhost:3001" : "",
  NEW_API_URL: ZORROCORE_BASE_URL,

  // Feature mapping between old and new systems
  FEATURE_MAPPING: {
    photoshoot: "fashion_photoshoot",
    moodboard: "inspiration_board_image",
    moodboardText: "inspiration_board_text",
    moodboardImage: "inspiration_board_image",
    garmentEditor: "product_editor",
    variationGenerator: "product_design_variations",
    productViewGenerator: "product_view_generator",
    masterCatalogItem: "product_catalogue_management",
    techpack: "techpack",
    colorChanger: "color_changer",
    instagramPhotoshoot: "instagram-photoshoot",
  },

  // Retry configuration for API calls
  RETRY_CONFIG: {
    maxRetries: 3,
    retryDelay: 1000, // 1 second
    backoffMultiplier: 2,
  },

  // Timeout configuration
  TIMEOUT_CONFIG: {
    defaultTimeout: 30000, // 30 seconds
    longRunningTimeout: 120000, // 2 minutes for operations like credit history
  },

  // Development/debugging options
  DEBUG_CONFIG: {
    logAPIRequests: process.env.NODE_ENV === "development",
    enableAPIComparison: process.env.ENABLE_API_COMPARISON === "true",
    enableFallback: process.env.ENABLE_API_FALLBACK === "true",
  },
};

/**
 * Helper function to get current API configuration
 */
export const getAPIConfig = () => ({
  isUsingNewAPI: MIGRATION_CONFIG.USE_NEW_API,
  apiUrl: MIGRATION_CONFIG.USE_NEW_API
    ? MIGRATION_CONFIG.NEW_API_URL
    : MIGRATION_CONFIG.OLD_API_URL,
  featureMapping: MIGRATION_CONFIG.FEATURE_MAPPING,
});

/**
 * Helper function to toggle API system (for testing)
 */
export const toggleAPISystem = () => {
  MIGRATION_CONFIG.USE_NEW_API = !MIGRATION_CONFIG.USE_NEW_API;
  console.log(
    `Switched to ${MIGRATION_CONFIG.USE_NEW_API ? "NEW" : "OLD"} API system`
  );
  return MIGRATION_CONFIG.USE_NEW_API;
};

/**
 * Helper function to set API system explicitly
 */
export const setAPISystem = (useNewAPI) => {
  MIGRATION_CONFIG.USE_NEW_API = Boolean(useNewAPI);
  console.log(
    `Set to ${MIGRATION_CONFIG.USE_NEW_API ? "NEW" : "OLD"} API system`
  );
  return MIGRATION_CONFIG.USE_NEW_API;
};
